import React from 'react';
import { motion } from 'framer-motion';
import { OPERATION_FLOW } from '../../data/solutions';
export function OperationFlow({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const dark = tone === 'dark';
  return <ol className="grid grid-cols-2 gap-px sm:grid-cols-4 lg:grid-cols-7" aria-label="Flujo de la operación de punta a punta" data-id="element-230" data-mp="3bg07tnry3yok">
      {OPERATION_FLOW.map((step, i) => <motion.li key={step} initial={{
      opacity: 0,
      y: 8
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.24,
      delay: i * 0.04,
      ease: [0.23, 1, 0.32, 1]
    }} className={`relative px-4 py-5 ${dark ? 'bg-graphite-800' : 'bg-mist-50'}`} data-id="element-231" data-mp="2iqjf0p0eyfrt" data-mpi={i}>
          <span className={`font-display text-xs font-bold tabular-nums ${dark ? 'text-accent-400' : 'text-accent-600'}`} data-id="element-232" data-mp="2xgqr8mztv2k2">
            {String(i + 1).padStart(2, '0')}
          </span>
          <span className={`mt-2 block font-display text-sm font-semibold uppercase tracking-[0.08em] ${dark ? 'text-white' : 'text-graphite-900'}`} data-id="element-233" data-mp="24xuzhxfaxeg8">
            {step}
          </span>
        </motion.li>)}
    </ol>;
}